<template>
  <div>
    <v-card>
      <v-card-text>
        <div class="text--primary">
          <v-row dense>
            <v-col cols="12" sm="4">
              <span class="caption font-weight-bold">Tipo de frete</span>
              <div>
                {{ solicitacao.respostaCotacaoConjunta.frete.tipoFrete | naoInformado }}
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <span class="caption font-weight-bold">Prazo de embarque</span>
              <div>
                {{ solicitacao.respostaCotacaoConjunta.frete.prazoEntrega
                  | pluralize(['dia útil', 'dias úteis']) }}
              </div>
            </v-col>
            <v-col cols="12" sm="4">
              <span class="caption font-weight-bold">Válido até</span>
              <div>
                {{ solicitacao.respostaCotacaoConjunta.validade | date | naoInformado }}
              </div>
            </v-col>
          </v-row>
          <v-row dense class="mt-3">
            <v-col cols="12" sm="4">
              <span class="caption font-weight-bold">Observação</span>
              <div>
                <px-show-large-text
                  :large-text="solicitacao.respostaCotacaoConjunta.observacao"
                />
              </div>
            </v-col>
            <v-col cols="12" sm="6">
              <span class="caption font-weight-bold">Observação do frete</span>
              <div>
                <px-show-large-text
                  :large-text="solicitacao.respostaCotacaoConjunta.frete.observacaoFrete"
                />
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
export default {
  props: {
    solicitacao: Object,
  },
};
</script>
